import { Pipe, PipeTransform } from '@angular/core';
import * as dayjs from 'dayjs';

@Pipe({
    name: 'liebherrIsBefore',
})
export class IsBeforePipe implements PipeTransform {
    /**
     * Checks wether the given Date is before a provied Date or the current Date when no second argument is provided.
     *
     * @param date Date String
     * @param dateToCheckAgainst Date String to check against
     */
    transform(date?: string, dateToCheckAgainst?: string): boolean {
        const shouldBeAfter = dateToCheckAgainst ? dayjs(dateToCheckAgainst) : dayjs();
        if (date === undefined) return false;
        return dayjs(date).isBefore(shouldBeAfter, 'day');
    }
}
